import superagent from 'superagent';

const URL = '/lm/v1/reports';

export const distinctValues = (field, callback) => {
    superagent.get(URL + '/distinct')
        .query({ field })
        .end((err, response) => {
            if (err || !response || response.status !== 200) {
                console.log('distinctValues failed for field "' + field + '": ' + (err ? err.message : 'status ' + (response && response.status)));
                callback([]);
            } else {
                callback(Array.isArray(response.body) ? response.body : []);
            }
        });
};

export const generate = (filters, callback) => {
    superagent.post(URL)
        .send(filters)
        .end((err, response) => {
            console.log(response)
            if (err) {
                if (response && response.status === 413) {
                    callback(null, response.body && response.body.message);
                } else {
                    callback(null);
                }
            } else {
                if (response.status === 200) {
                    callback(response.body)
                } else {
                    callback(null)
                }
            }
        });
};
